import React from 'react';

const InternetExplorerWarning = () => (
  <div className='internet-explorer-warning'>
    <div>This application does not support Internet Explorer.</div>
  </div>
);

export default InternetExplorerWarning;
